import { AppHelper } from "../../appHelper";
import { Helper } from "../../core/util/helper";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { General } from "../../../siteManagement/general";
import { AppBaseProps, CommonApp, Entity } from "../../core/components/commonApp";
import { SheetEventType } from "../../../siteManagement/sheet";
import React from "react";

export class TimeType extends React.Component<TimeTypeProps, any>{
    common = new AppHelper();
    translations: {};
    constructor(props: TimeTypeProps) {
        super(props);
        this.common.init(this);
    }

    private validate = () => {
        if (this.common.validate()) {
            const keys = Object.keys(this.props.entity.Translations);
            for (let i = 0; i < keys.length; i++) {
                if (!Helper.isNullOrEmpty(this.props.entity.Translations[keys[i]])) {
                    return true;
                }
            }
            NotificationHelper.showWarningMessage(this.translations["WebSMS.Report.Question.Messages.TitlesNotTranslated"]);
        }
        return false;
    }

    save = async () => {
        if (this.validate()) {
            let result = await HTTPService.post<JsonResultClass<TimeTypeEntity>>("TimeType/SaveTimeType", { model: this.props.entity });
            if (result.Code == 0) {
                Helper.updateEntity(this.props.entity, result.Data);
                NotificationHelper.showSuccessMessage(result.Message);
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
            this.common.handlePostSave(result.Code == 0, this.props.closeAfterSave);
        }
    }

    deleteType = async () => {
        const isDeleted = await this.props.delete(this.props.entity.Id);
        if (isDeleted) {
            General.Sheet.Manager.getTopMostSheet().hide();
        }
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <><CommonApp {...props} /></>;
    }
}

export interface TimeTypeProps extends AppBaseProps {
    entity: TimeTypeEntity;
    delete?: (id: string) => Promise<boolean>;
    closeAfterSave: boolean;
}

export interface TimeTypeEntity extends Entity {
    Id: string;
    Type: number;
    Category: "Work" | "Travel" | "Break";
    AllowAfterSign: boolean;
    Translations: {};
    Displayname: string;
}